import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./App";
import "./styles/tokens.css";
import "./styles/chat.css";
import "./styles/console.css"; // console.css (created in Task 3)
import "./styles/builder.css"; // P2d builder scope (agent-builder edit view, CDS tokens)
import "./styles/review.css"; // /review annotation console (阶段②, Cycle DS tokens)
import "./styles/playbook.css"; // CycleCare Playbook overlay + home entries (#90)
import "./styles/scheduler.css"; // Schedule/Routines page (schedule-tasks.md)
import "./styles/whatsnew.css"; // top-bar 新功能 (What's New) entry
import "./styles/loom-replay.css"; // FEATURE_IA_REPLAY inline loom-session replay (LOOM-COUPLED)
import "./styles/meeting.css"; // FEATURE_MEETING meeting-summary block + surface
import "./styles/settings.css"; // FEATURE_SETTINGS /settings audit surface

// Apply the saved light/dark choice before first paint (avoids a flash).
const savedMode = localStorage.getItem("cyclecare_mode");
if (savedMode === "light" || savedMode === "dark") {
  document.documentElement.setAttribute("data-mode", savedMode);
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");
createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </StrictMode>
);
